var definitionList = 'fx_e395032e_14nggi00';

export { definitionList };
//# sourceMappingURL=definitionList.vanilla.mjs.map
